import Request, { GET, POST } from '@/plugins/sdk/Request'

export default class {
  async printLabel (consignment) {
    const request = Object.assign(new Request(), {
      _pathname: `/legacy/label?consignment=${consignment.id}`,
      method: GET
    })
    let res = await fetch(await request.build())
    let data = await res.json()

    if (data.label_pdf) {
      window.open(atob(data.label_pdf), '_blank')
    }
  }

  async printConnote (consignment) {
    const request = Object.assign(new Request(), {
      _pathname: `/legacy/label?consignment=${consignment.id}`,
      method: GET
    })
    let res = await fetch(await request.build())
    let data = await res.json()

    if (data.connote_pdf) {
      window.open(atob(data.connote_pdf), '_blank')
    }
  }

  async printDG (consignment) {
    const request = Object.assign(new Request(), {
      _pathname: `/legacy/label?consignment=${consignment.id}`,
      method: GET
    })
    let res = await fetch(await request.build())
    let data = await res.json()

    if (data.dg_pdf) {
      window.open(atob(data.dg_pdf), '_blank')
    }
  }

  async printInvoice (consignment) {
    const request = Object.assign(new Request(), {
      _pathname: `/legacy/label?consignment=${consignment.id}`,
      method: GET
    })
    let res = await fetch(await request.build())
    let data = await res.json()

    if (data.invoice_pdf) {
      window.open(atob(data.invoice_pdf), '_blank')
    }
  }

  async printManifest (consignment) {
    const request = Object.assign(new Request(), {
      _pathname: `/legacy/manifest?consignment=${consignment.id}`,
      method: GET
    })
    let res = await fetch(await request.build())
    let data = await res.json()

    if (data.manifest_pdf) {
      window.open(atob(data.manifest_pdf), '_blank')
    }
  }
}

export async function createManifest (consignment) {
  const request = Object.assign(new Request(), {
    _pathname: `/legacy/manifest`,
    method: POST,
    body: {
      consignments: [consignment.id]
    }
  })
  let res = await fetch(await request.build())
  let data = await res.json()

  if (data.manifest_pdf) {
    window.open(atob(data.manifest_pdf), '_blank')
  }
}
